var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "myInquiry_list" }, [
      _c("div", { staticClass: "Head_box" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "align-items": "center" } },
          [
            _c("div", { staticClass: "avatar" }, [
              _c("img", {
                staticStyle: { "border-radius": "50%" },
                attrs: {
                  src: _vm.item.imageUrl,
                  height: "100%",
                  width: "100%",
                },
              }),
            ]),
            _c("div", { staticStyle: { "margin-left": "10px" } }, [
              _c("div", { staticClass: "nickName" }, [
                _vm._v(_vm._s(_vm.item.createName)),
              ]),
              _c("div", { staticClass: "time" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.myLineInquiry == 4 ? "客户" : "您") +
                    "于" +
                    _vm._s(_vm.dateFormatYMD(_vm.item.createTime, ".")) +
                    "日" +
                    _vm._s(_vm.dateFormatHM(_vm.item.createTime)) +
                    "分提出一个 "
                ),
                _vm.item.resourceType != 0 && !_vm.item.resourceType
                  ? _c("span", [_vm._v("询价需求")])
                  : _c("span", [
                      _c("span", { staticClass: "Icon" }, [
                        _vm._v(
                          _vm._s(_vm.resouceTypeObj[_vm.item.resourceType])
                        ),
                      ]),
                      _vm._v(" 询价"),
                    ]),
                _vm._v("   "),
                _vm.item.planId && _vm.item.planId != ""
                  ? _c("span", [_vm._v("行程：" + _vm._s(_vm.item.planId))])
                  : _vm._e(),
                _vm.item.condition === 0
                  ? _c("span", { staticClass: "cancelbtn" }, [_vm._v("取消")])
                  : _vm._e(),
                _vm.item.condition === 1
                  ? _c("span", { staticClass: "cancelbtn1" }, [
                      _vm._v("已取消"),
                    ])
                  : _vm._e(),
                _vm.rightShow
                  ? _c(
                      "a",
                      {
                        staticStyle: { color: "blue" },
                        on: {
                          click: function ($event) {
                            return _vm.getInquiryLog(_vm.item)
                          },
                        },
                      },
                      [_vm._v("操作记录")]
                    )
                  : _vm._e(),
                _c("span", { staticClass: "Icon" }, [
                  _vm._v(
                    _vm._s(
                      _vm.item.status == 4
                        ? "已发送报价给客户"
                        : _vm.item.status == 5
                        ? "已撤回报价"
                        : _vm.item.status == 6
                        ? "客户已购买"
                        : ""
                    )
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _vm.rightShow
          ? _c("div", { staticStyle: { position: "relative" } }, [
              _c("div", { staticClass: "bubble_box" }, [
                _vm.item.newNumber != 0 || _vm.item.readNumber != 0
                  ? _c("div", [
                      _c("div", [
                        _vm._v("已收到库存"),
                        _c("span", { staticClass: "numberBox" }, [
                          _vm._v(_vm._s(_vm.item.readNumber)),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm.myLineInquiry == 4 && !_vm.item.fromInquiryId
                  ? _c("div", { staticClass: "box1" }, [_vm._v("待转询")])
                  : _vm.item.newNumber === 0 && _vm.item.readNumber === 0
                  ? _c("div", { staticClass: "box1" }, [_vm._v("方案制作中 ")])
                  : _vm._e(),
                _c("i", {
                  staticClass: "el-icon-caret-bottom",
                  staticStyle: {
                    "font-size": "0.2rem",
                    color: "#E64A19",
                    "margin-top": "-7px",
                  },
                }),
              ]),
              _c("div", { staticClass: "inquiryId" }, [
                _vm._v("询单号：" + _vm._s(_vm.item.inquiryId)),
              ]),
            ])
          : _vm._e(),
      ]),
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "left" },
          [
            _vm.myLineInquiry == 2 || _vm.myLineInquiry == 4
              ? _c("div", [
                  _c("div", { staticClass: "left_item" }, [
                    _c("div", { staticClass: "titleTwo" }, [_vm._v("人数：")]),
                    _c("div", { staticClass: "contentTwo" }, [
                      _vm._v(_vm._s(_vm.item.peopleNumber)),
                    ]),
                  ]),
                  _vm.item.planInfo && _vm.item.planInfo.length > 0
                    ? _c("div", { staticClass: "left_item" }, [
                        _c("div", { staticClass: "titleTwo" }, [
                          _vm._v("行程："),
                        ]),
                        _c(
                          "div",
                          { staticClass: "contentTwo" },
                          _vm._l(_vm.item.planInfo, function (item1, index) {
                            return _c("span", { key: index }, [
                              _vm._v(_vm._s(item1) + "  "),
                            ])
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "left_item" }, [
                    _c("div", { staticClass: "titleTwo" }, [_vm._v("需求：")]),
                    _c(
                      "div",
                      { staticClass: "contentTwo" },
                      _vm._l(_vm.item.needDetail, function (item1, index) {
                        return _c(
                          "span",
                          {
                            key: index,
                            staticStyle: { "line-height": "0.2rem" },
                          },
                          [
                            item1 == "<br>"
                              ? _c("br")
                              : _c(
                                  "span",
                                  {
                                    style:
                                      item1 == "和" || item1 == "或"
                                        ? "font-weight: bold;color: #DB4E1A;"
                                        : "",
                                  },
                                  [_vm._v(_vm._s(item1) + "  ")]
                                ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm.item.hotelRoomList && _vm.item.hotelRoomList.length > 0
                    ? _c(
                        "div",
                        { staticClass: "productList" },
                        _vm._l(_vm.item.hotelRoomList, function (product, ind) {
                          return _c(
                            "div",
                            { key: ind, staticClass: "list_item" },
                            [
                              _c("i", { staticClass: "el-icon-video-play" }),
                              _vm._v(
                                " " +
                                  _vm._s(product.hotelRoomName) +
                                  "  " +
                                  _vm._s(product.roomNumber) +
                                  "间   "
                              ),
                              product.price != ""
                                ? _c("span", [
                                    _vm._v(
                                      "锁死预算：" +
                                        _vm._s(product.roomBudget) +
                                        _vm._s(product.currency) +
                                        "/间/晚"
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ])
              : _c("information-inquiry-info", { attrs: { item: _vm.item } }),
          ],
          1
        ),
        _vm.rightShow
          ? _c("div", { staticClass: "right" }, [
              _vm.myLineInquiry == 2 || _vm.myLineInquiry == 4
                ? _c("div", { staticClass: "up" }, [
                    (_vm.myLineInquiry == 2 ||
                      (_vm.myLineInquiry == 4 && _vm.item.fromInquiryId)) &&
                    _vm.item.newNumber === 0 &&
                    _vm.item.readNumber === 0
                      ? _c("p", [_vm._v(" 请您再耐心等待一下哦")])
                      : _vm.myLineInquiry == 4 && !_vm.item.fromInquiryId
                      ? _c(
                          "div",
                          { staticClass: "down_button" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.zhaunxun(_vm.item)
                                  },
                                },
                              },
                              [_vm._v("转询")]
                            ),
                          ],
                          1
                        )
                      : _c("div", { staticClass: "down_button" }, [
                          _c("i", {
                            staticClass: "el-icon-arrow-down",
                            staticStyle: {
                              "font-size": "0.25rem",
                              color: "#E64A19",
                              "font-weight": "bold",
                              "line-height": "0.25rem",
                              cursor: "pointer",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.showProgramListTwo(_vm.item)
                              },
                            },
                          }),
                        ]),
                  ])
                : _vm._e(),
              _vm.myLineInquiry == 1
                ? _c(
                    "div",
                    [
                      _vm._l(
                        _vm.item.sendCustomizerList,
                        function (item1, index1) {
                          return _c("div", { key: index1 }, [
                            _c("img", {
                              staticStyle: {
                                width: "0.3rem",
                                height: "0.3rem",
                                "border-radius": "50%",
                              },
                              attrs: { src: item1.imageUrl },
                            }),
                            _c("i", {
                              staticClass: "el-icon-arrow-down",
                              staticStyle: {
                                "font-size": "0.25rem",
                                color: "#E64A19",
                                "font-weight": "bold",
                                "line-height": "0.25rem",
                                cursor: "pointer",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showPlanListTwo(_vm.item, item1)
                                },
                              },
                            }),
                          ])
                        }
                      ),
                      _vm.item.sendCustomizerList &&
                      _vm.item.customizerNumber >
                        _vm.item.sendCustomizerList.length
                        ? _c("div", { staticClass: "up" }, [
                            _vm._v(
                              " 将有" +
                                _vm._s(
                                  _vm.item.customizerNumber -
                                    _vm.item.sendCustomizerList.length
                                ) +
                                "位定制师为您发送方案,请您再耐心等待一下哦 "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }